import { render, staticRenderFns } from "./MenuInfo.vue?vue&type=template&id=322ba8d5&scoped=true&"
import script from "./MenuInfo.vue?vue&type=script&lang=js&"
export * from "./MenuInfo.vue?vue&type=script&lang=js&"
import style0 from "./MenuInfo.vue?vue&type=style&index=0&id=322ba8d5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322ba8d5",
  null
  
)

export default component.exports